<div class="row">
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header">
                <div class="card-header--title">
                    <b>Monthly targets</b>
                    <small class="d-block text-capitalize mt-1">Card with progress bars list items.</small>
                </div>
                <div class="card-header--actions">
                    <div class="btn-group btn-block" dropdown placement="bottom right">
                        <button class="btn btn-link btn-link-primary p-0 font-size-xl text-primary dropdown-toggle no-caret"
                                dropdownToggle
                                type="button">
                            <fa-icon [icon]="['fas', 'ellipsis-h']" class="font-size-lg"></fa-icon>
                        </button>
                        <div *dropdownMenu
                             class="dropdown-menu dropdown-menu-right dropdown-menu-xxl overflow-hidden p-0">
                            <div class="grid-menu grid-menu-2col">
                                <div class="no-gutters row">
                                    <div class="col-sm-6">
                                        <button class="btn border-0 w-100 btn-transition-none rounded-0 shadow-none btn-outline-gray py-4 px-1"
                                                type="button">
                                            <fa-icon [icon]="['far', 'bell']"
                                                     class="h2 d-block mb-2 mt-1 text-success"></fa-icon>
                                            <div class="font-weight-bold text-black">Reports</div>
                                            <div class="font-size-md mb-1 text-black-50">Monthly Stats</div>
                                        </button>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn border-0 w-100 btn-transition-none rounded-0 shadow-none btn-outline-gray py-4 px-1"
                                                type="button">
                                            <fa-icon [icon]="['far', 'file-excel']"
                                                     class="h2 d-block mb-2 mt-1 text-success"></fa-icon>
                                            <div class="font-weight-bold text-black">Statistics</div>
                                            <div class="font-size-md mb-1 text-black-50">Customers stats</div>
                                        </button>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn border-0 w-100 btn-transition-none rounded-0 shadow-none btn-outline-gray py-4 px-1"
                                                type="button">
                                            <fa-icon [icon]="['far', 'eye']"
                                                     class="h2 d-block mb-2 mt-1 text-success"></fa-icon>
                                            <div class="font-weight-bold text-black">Projects</div>
                                            <div class="font-size-md mb-1 text-black-50">Manage servers</div>
                                        </button>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn border-0 w-100 btn-transition-none rounded-0 shadow-none btn-outline-gray py-4 px-1"
                                                type="button">
                                            <fa-icon [icon]="['far', 'chart-bar']"
                                                     class="h2 d-block mb-2 mt-1 text-success"></fa-icon>
                                            <div class="font-weight-bold text-black">Tasks</div>
                                            <div class="font-size-md mb-1 text-black-50">Pending items</div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ul class="list-group list-group-flush">
                <li class="list-group-item py-2">
                    <div class="align-box-row mb-1">
                        <div>
                            <div class="font-weight-bold">Orders</div>
                        </div>
                        <div class="ml-auto">
                            <div class="font-size-xl font-weight-bold text-success">
                                348
                            </div>
                        </div>
                    </div>
                    <progressbar [animate]="true" [value]="34" class="progress-animated-alt" type="success">34%
                    </progressbar>
                    <div class="align-box-row progress-bar--label mt-1 text-muted">
                        <small class="text-dark">0</small>
                        <div class="ml-auto">100%</div>
                    </div>
                </li>
                <li class="list-group-item py-2">
                    <div class="align-box-row mb-1">
                        <div>
                            <div class="font-weight-bold">Sales</div>
                        </div>
                        <div class="ml-auto">
                            <div class="font-size-xl font-weight-bold text-danger">
                                <small>$</small>
                                2.3M
                            </div>
                        </div>
                    </div>
                    <progressbar [animate]="true" [value]="39" class="progress-animated-alt" type="danger">39%
                    </progressbar>
                    <div class="align-box-row progress-bar--label mt-1 text-muted">
                        <small class="text-dark">0</small>
                        <div class="ml-auto">100%</div>
                    </div>
                </li>
                <li class="list-group-item py-2">
                    <div class="align-box-row mb-1">
                        <div>
                            <div class="font-weight-bold">Users</div>
                        </div>
                        <div class="ml-auto">
                            <div class="font-size-xl font-weight-bold text-info">
                                <small>#</small>
                                87
                            </div>
                        </div>
                    </div>
                    <progressbar [animate]="true" [value]="51" class="progress-animated-alt" type="info">51%
                    </progressbar>
                    <div class="align-box-row progress-bar--label mt-1 text-muted">
                        <small class="text-dark">0</small>
                        <div class="ml-auto">100%</div>
                    </div>
                </li>
            </ul>
            <div class="card-footer bg-light p-4 text-center">
                <button class="btn btn-second" type="button">
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['far', 'question-circle']" class="font-size-lg"></fa-icon>
                    </span>
                    <span class="btn-wrapper--label">
                        View details
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header bg-light">
                <div class="card-header--title">
                    <small class="d-block text-uppercase mt-1">Progress</small>
                    <b>Users Analytics</b>
                </div>
                <div class="card-header--actions">
                    <div class="badge badge-pill badge-dark">
                        Pending
                    </div>
                </div>
            </div>
            <ul class="list-group list-group-flush">
                <li class="list-group-item">
                    <div class="align-box-row">
                        <div class="mr-4">
                            <a [routerLink]="" class="avatar-icon-wrapper avatar-icon-lg m-0"
                               placement="right" tooltip="View details">
                                <div class="dot-badge"></div>
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar7.jpg"/></div>
                            </a>
                        </div>
                        <div class="flex-grow-1">
                            <progressbar [animate]="true" [value]="61"
                                         class="progress-bar-rounded progress-animated-alt"
                                         type="success">61%
                            </progressbar>
                        </div>
                        <div class="line-height-sm text-center ml-4">
                            <small class="text-black-50 d-block text-uppercase">Totals</small>
                            <b class="font-size-lg text-success">
                                <small class="text-black-50">$</small>
                                1,628
                            </b>
                        </div>
                    </div>
                </li>
                <li class="list-group-item">
                    <div class="align-box-row">
                        <div class="mr-4">
                            <a [routerLink]="" class="avatar-icon-wrapper avatar-icon-lg m-0"
                               placement="right" tooltip="View details">
                                <div class="dot-badge"></div>
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar5.jpg"/></div>
                            </a>
                        </div>
                        <div class="flex-grow-1">
                            <progressbar [animate]="true" [value]="44"
                                         class="progress-bar-rounded progress-animated-alt"
                                         type="info">44%
                            </progressbar>
                        </div>
                        <div class="line-height-sm text-center ml-4">
                            <small class="text-black-50 d-block text-uppercase">Totals</small>
                            <b class="font-size-lg text-info">
                                <small class="text-black-50">$</small>
                                7,389
                            </b>
                        </div>
                    </div>
                </li>
                <li class="list-group-item">
                    <div class="align-box-row">
                        <div class="mr-4">
                            <a [routerLink]="" class="avatar-icon-wrapper avatar-icon-lg m-0"
                               placement="right" tooltip="View details">
                                <div class="dot-badge"></div>
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                            </a>
                        </div>
                        <div class="flex-grow-1">
                            <progressbar [animate]="true" [value]="29"
                                         class="progress-bar-rounded progress-animated-alt"
                                         type="danger">29%
                            </progressbar>
                        </div>
                        <div class="line-height-sm text-center ml-4">
                            <small class="text-black-50 d-block text-uppercase">Totals</small>
                            <b class="font-size-lg text-danger">
                                <small class="text-black-50">$</small>
                                8,493
                            </b>
                        </div>
                    </div>
                </li>
                <li class="list-group-item">
                    <div class="align-box-row">
                        <div class="mr-4">
                            <a [routerLink]="" class="avatar-icon-wrapper avatar-icon-lg m-0"
                               placement="right" tooltip="View details">
                                <div class="dot-badge"></div>
                                <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                            </a>
                        </div>
                        <div class="flex-grow-1">
                            <progressbar [animate]="true" [value]="38"
                                         class="progress-bar-rounded progress-animated-alt"
                                         type="warning">38%
                            </progressbar>
                        </div>
                        <div class="line-height-sm text-center ml-4">
                            <small class="text-black-50 d-block text-uppercase">Totals</small>
                            <b class="font-size-lg text-warning">
                                <small class="text-black-50">$</small>
                                2,594
                            </b>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="card-footer bg-light text-center">
                <button class="btn btn-sm btn-first" type="button">
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['far', 'question-circle']"></fa-icon>
                    </span>
                    <span class="btn-wrapper--label">
                        Generate reports
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>
